<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="invoiceDetail" class="container py-3">
    <button *ngIf="invoiceDetail.STATUS !== 'Done' && invoiceDetail.STATUS !== 'Cancel'" class="btn btn-outline-danger"
        style="position: absolute; right: 3%;" (click)="cancel(id)">
        ยกเลิกใบแจ้งหนี้
    </button>

    <h1 class="text-center lifedi-color mb-5">
        <span *ngIf="!isEdit">
            สร้างใบแจ้งหนี้
        </span>
        <span *ngIf="isEdit">
            <span *ngIf="!partial">
                ใบแจ้งหนี้ {{ invoiceDetail.INVOICE_NO }}
            </span>
            <span *ngIf="partial">
                ใบแจ้งหนี้ {{ invoiceDetail.INVOICE_NO }} (แบ่งจ่าย)
            </span>
        </span>
    </h1>

    <div class="row d-flex justify-content-center" [ngClass]="getClass()">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <p class="text-left mt-3">
                <b>หมายเลขเอกสารใบเสนอราคา {{ invoiceDetail.QUOTATION_NO }} </b>
            </p>
            <mat-card class="p-3" style="width: 100%;">
                <div class="row justify-content-end px-3">
                    <button *ngIf="invoiceForm.valid" (click)="print(invoiceForm.value)" mat-button
                        class="print-btn mx-3">
                        <img src="assets/printer.png" alt="print">
                    </button>
                    <button *ngIf="!invoiceForm.valid" mat-button class="print-btn-disable mx-3" disabled>
                        <img src="assets/printer.png" alt="print">
                    </button>
                </div>

                <form [formGroup]="invoiceForm">
                    <div class="row justify-content-center px-3">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group">
                                <label for="courseType" class="form-label">
                                    ชื่อลูกค้า<lifedi-require></lifedi-require>
                                </label>
                                <input type="text" class="form-control" formControlName="name" readonly>
                            </div>
                            <div class="form-group">
                                <label for="detail" class="form-label">
                                    ข้อมูลลูกค้า<lifedi-require></lifedi-require>
                                </label>
                                <textarea class="form-control" id="detail" formControlName="detail" rows="5"
                                    (keyup)="onCreateGroupFormValueChange()"></textarea>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="form-group">
                                <label for="title" class="form-label">
                                    หัวข้อ<lifedi-require></lifedi-require>
                                </label>
                                <input id="title" type="text" class="form-control" formControlName="title" readonly>
                            </div>
                            <div class="form-group">
                                <label for="taxId" class="form-label">
                                    เลขประจำตัวผู้เสียภาษี<lifedi-require></lifedi-require>
                                </label>
                                <input id="taxId" type="text" class="form-control" MaxLength="13" autocomplete="off"
                                    formControlName="taxId" readonly>
                            </div>
                            <div class="form-group">
                                <label for="date" class="form-label">
                                    วันที่ - วันที่ครบกำหนด<lifedi-require></lifedi-require>
                                </label>
                                <input id="date" class="form-control" [(ngModel)]="date"
                                    (ngModelChange)="selectDate($event, invoiceForm)"
                                    (ngModelChange)="onCreateGroupFormValueChange()"
                                    [ngModelOptions]="{standalone: true}" date-format="dd-MM-yyyy HH:mm:ss"
                                    [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker"
                                    [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off">
                                <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex justify-content-center my-4">
                        <div *ngFor="let col of column; let i = index" [class]="col.class">
                            <p class="text-center">
                                <b>{{col.header}}</b>
                                <span *ngIf="i !== 0 && i !== column.length - 1">
                                    <lifedi-require></lifedi-require>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="disable-display">
                        <div *ngFor="let w of invoiceForm.get('lists')['controls']; let i = index" formArrayName="lists"
                            class="my-3">
                            <div class="row d-flex justify-content-center" [formGroupName]="i">
                                <div class="col-1">
                                    <p class="text-center">{{ i + 1 }}</p>
                                </div>
                                <div class="col-4 pl-0">
                                    <textarea class="form-control" formControlName="list" rows="3"></textarea>
                                </div>
                                <div class="col-1 p-0">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="number"
                                        (ngModelChange)="getTotal(invoiceFormArray, i)"
                                        (ngModelChange)="getSummary(invoiceFormArray)"
                                        (ngModelChange)="detectNumber($event, invoiceFormArray.at(i).controls['number'])"
                                        (ngModelChange)="onCreateGroupFormValueChange()" [nzFormatter]="formatterPrice">
                                    </nz-input-number>
                                </div>
                                <div class="col-2">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="unitPrice"
                                        (ngModelChange)="getTotal(invoiceFormArray, i)"
                                        (ngModelChange)="getSummary(invoiceFormArray)"
                                        (ngModelChange)="detectNumber($event, invoiceFormArray.at(i).controls['unitPrice'])"
                                        (ngModelChange)="onCreateGroupFormValueChange()" [nzFormatter]="formatterPrice">
                                    </nz-input-number>
                                </div>
                                <div class="col-1 p-0">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="discount"
                                        (ngModelChange)="getTotal(invoiceFormArray, i)"
                                        (ngModelChange)="getSummary(invoiceFormArray)"
                                        (ngModelChange)="detectNumber($event, invoiceFormArray.at(i).controls['discount'])"
                                        (ngModelChange)="onCreateGroupFormValueChange()" [nzFormatter]="formatterPrice">
                                    </nz-input-number>
                                </div>
                                <div class="col-2">
                                    <p class="text-center">
                                        <b>{{ invoiceFormArray.value[i].total | number : '1.2-2' }} บาท</b>
                                    </p>
                                </div>
                                <div class="col-1">
                                    <img *ngIf="invoiceFormArray.value.length > 1" src="assets/close.png" class="img"
                                        style="width: 30px; height: 30px; cursor: pointer;"
                                        (click)="removeGroup(i, invoiceForm)">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row justify-content-center disable-display">
                    <img src="assets/add.png" class="img my-4" style="width: 30px; height: 30px; cursor: pointer;"
                        (click)="addGroup()">
                </div>

                <div class="container px-4 py-4">
                    <div class="row d-flex justify-content-center">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <form [formGroup]="invoiceForm">
                                <label for="note" class="form-label">หมายเหตุ</label>
                                <textarea class="form-control" id="note" formControlName="note" rows="5"
                                    (keyup)="onCreateGroupFormValueChange()"></textarea>
                            </form>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div class="row disable-display">
                                <div class="col-6">
                                    <p class="text-left">รวมเงิน</p>
                                    <p class="text-left text-danger">ส่วนลด</p>
                                    <p class="text-left">ราคาไม่รวมภาษีมูลค่าเพิ่ม</p>
                                    <mat-checkbox id="vat" [ngClass]="vat ? '' : 'text-secondary'" [(ngModel)]="vat"
                                        (change)="calNetPrice()" class="form-control-plaintext p-0">
                                        ภาษีมูลค่าเพิ่ม (7%)
                                    </mat-checkbox>
                                    <h5 class="text-left text-primary mt-4">รวมราคาสุทธิ</h5>
                                </div>
                                <div class="col-6">
                                    <p class="text-right">{{ total | number : '1.2-2' }} บาท</p>
                                    <p class="text-right text-danger">{{ discount | number : '1.2-2' }} บาท</p>
                                    <p class="text-right">{{ priceWithoutVat | number : '1.2-2' }} บาท</p>
                                    <p class="text-right" [ngClass]="vat ? '' : 'text-secondary'">
                                        {{ vatPrice | number : '1.2-2' }} บาท
                                    </p>
                                    <h5 class="text-right text-primary" style="margin-top: 36px;">
                                        {{ totalNetPrice | number : '1.2-2' }} บาท</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="partial" class="container">
                    <hr width="100%">
                    <form [formGroup]="invoiceForm">
                        <div class="form-group row justify-content-center my-4">
                            <label for="installmentType" class="col-form-label col-1 text-right">แบ่งชำระ</label>
                            <div class="col-2">
                                <select class="custom-select form-control" style="display: inline;" disabled>
                                    <option selected>
                                        ตามจำนวนเงิน
                                    </option>
                                    <!-- <option *ngFor="let s of installmentList" [id]="s.value" [value]="s.value">
                                        {{ s.label }}
                                    </option> -->
                                </select>
                            </div>
                            <div class="col-1">
                                <!-- <label *ngIf="invoiceForm.value.type === 'percent'" for="installmentType"
                                    class="col-form-label text-right">เปอร์เซ็นต์</label> -->
                            </div>
                            <div class="col-2">
                                <!-- <input *ngIf="invoiceForm.value.type === 'percent'" type="number"
                                    class="form-control" formControlName="percent"> -->
                            </div>
                            <label for="installmentType" class="col-form-label col-1 text-right"
                                style="margin-top: 20px;">จำนวนเงิน</label>
                            <div class="col-2">
                                <small class="text-secondary" *ngIf="isEdit">
                                    <span *ngIf="invoiceDetail.STATUS !== 'Done'">
                                        ยอดคงเหลือจ่าย {{ invoiceDetail.Unpaid_Amount + invoiceDetail.TOTAL | number :
                                        '1.2-2' }} บาท
                                    </span>
                                    <span *ngIf="invoiceDetail.STATUS === 'Done'">
                                        ยอดคงเหลือจ่าย {{ invoiceDetail.Unpaid_Amount | number : '1.2-2' }} บาท
                                    </span>
                                </small>
                                <small class="text-secondary" *ngIf="!isEdit">
                                    ยอดคงเหลือจ่าย {{ balance | number : '1.2-2' }} บาท
                                </small>
                                <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="total"
                                    (ngModelChange)="detectNumber($event, invoiceForm.controls['total'])"
                                    (ngModelChange)="checkPartialTotal(invoiceForm.value.total, invoiceForm.controls['total'])"
                                    [nzFormatter]="formatterPrice">
                                </nz-input-number>
                                <small *ngIf="isEdit" class="text-right text-danger">
                                    <span
                                        *ngIf="invoiceForm.value.total > (invoiceDetail.Unpaid_Amount + invoiceDetail.TOTAL)">
                                        ยอดเงินมากกว่ายอดเงินคงเหลือ</span>
                                </small>
                                <small *ngIf="!isEdit" class="text-right text-danger">
                                    <span *ngIf="invoiceForm.value.total > balance">
                                        ยอดเงินมากกว่ายอดเงินคงเหลือ</span>
                                </small>
                            </div>
                            <label for="installmentType" class="col-form-label col-1"
                                style="margin-top: 20px;">บาท</label>
                        </div>
                        <div class="row justify-content-center mt-3">
                            <div class="col-5"></div>
                            <div class="col-2">
                                <!-- <p class="text-right">ยอดเงินคงเหลือ</p> -->
                                <h5 class="text-right text-primary">จำนวนเงินชำระทั้งสิ้น</h5>
                            </div>
                            <div class="col-2">
                                <!-- <p class="text-right">{{ invoiceDetail.Unpaid_Amount | number : '1.2-2'}}</p> -->
                                <h5 class="text-right text-primary" *ngIf="invoiceForm.value.total > 0">
                                    {{ invoiceForm.value.total | number : '1.2-2'}}
                                </h5>
                                <h5 class="text-right text-primary" *ngIf="invoiceForm.value.total == 0">0.00</h5>
                            </div>
                            <div class="col-1">
                                <!-- <p class="text-left">บาท</p> -->
                                <h5 class="text-left text-primary">บาท</h5>
                            </div>
                        </div>
                    </form>
                </div>
            </mat-card>
        </div>
    </div>

    <div *ngIf="!isEdit" class="row justify-content-center pb-5 pt-4">
        <lifedi-btn *ngIf="invoiceForm.valid" lable="บันทึก" (click)="save(invoiceForm.value)"
            customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
        <lifedi-btn *ngIf="!invoiceForm.valid" lable="บันทึก" disabled="true"
            customStyle="margin: 0px; padding: 0 30px;">
        </lifedi-btn>
    </div>

    <div *ngIf="isEdit" class="row justify-content-center pb-5 pt-4">
        <div *ngIf="invoiceDetail.STATUS !== 'Done' && invoiceDetail.STATUS !== 'Cancel'">
            <lifedi-btn *ngIf="invoiceForm.valid" lable="บันทึก" (click)="update(invoiceForm.value)"
                customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
            </lifedi-btn>
            <lifedi-btn *ngIf="!invoiceForm.valid" lable="บันทึก" disabled="true"
                customStyle="margin: 0px; padding: 0 30px;">
            </lifedi-btn>
            <lifedi-btn lable="ปิด" (click)="close()"
                customStyle="background-color: #A5A5A5; color: #FFF; margin: 0px 10px; padding: 0 30px;">
            </lifedi-btn>
        </div>
        <div *ngIf="invoiceDetail.STATUS === 'Done' || invoiceDetail.STATUS === 'Cancel'">
            <lifedi-btn lable="ปิด" (click)="close()"
                customStyle="background-color: #060E9F; color: #FFF; margin: 0px 10px; padding: 0 30px;">
            </lifedi-btn>
        </div>
    </div>

</div>

<div *ngIf="canPrint">
    <div *ngIf="printDetail.printData.detail.ACCOUNTING_NAME === 'คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย'">
        <lifedi-print-invoice-agency [printDetail]="printDetail"></lifedi-print-invoice-agency>
    </div>
    <div *ngIf="printDetail.printData.detail.ACCOUNTING_NAME === 'บริษัทผลิตภัณฑ์นวัตกรรมจามจุรี จำกัด'">
        <lifedi-print-invoice-organization [printDetail]="printDetail"></lifedi-print-invoice-organization>
    </div>
</div>

<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>